import React, { useEffect, useRef, useState } from 'react';
import {
  SearchGlyph, CaretGlyph, DownloadGlyph,
} from './icons';

const Dropdown = ({ label, value, options, onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const current = options.find((o) => o.value === value) || options[0];

  return (
    <div className="ma-dropdown" ref={ref}>
      <button type="button" className="ma-dropdown__btn" onClick={() => setOpen((v) => !v)}>
        <span className="ma-dropdown__label">{label}:</span>
        <span className="ma-dropdown__value">{current ? current.label : ''}</span>
        <CaretGlyph />
      </button>
      {open && (
        <div className="ma-dropdown__menu">
          {options.map((opt) => (
            <button
              type="button"
              key={opt.value}
              className={`ma-dropdown__item${opt.value === value ? ' ma-dropdown__item--active' : ''}`}
              onClick={() => { onChange(opt.value); setOpen(false); }}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'completed', label: 'Completed' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'not_started', label: 'Not Started' },
];

const SORT_OPTIONS = [
  { value: 'recent', label: 'Most recent' },
  { value: 'name', label: 'Name' },
  { value: 'progress', label: 'Progress' },
];

const Toolbar = ({
  search,
  onSearchChange,
  groupByLabel,
  statusFilter,
  onStatusChange,
  sort,
  onSortChange,
  onExportCsv,
  onImportCsv,
  onInviteUsers,
}) => (
  <div className="ma-toolbar">
    <div className="ma-toolbar__left">
      <div className="ma-search">
        <SearchGlyph />
        <input
          type="text"
          placeholder="Search by name or email..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <Dropdown
        label="Group by"
        value={groupByLabel}
        options={[{ value: groupByLabel, label: groupByLabel }]}
        onChange={() => {}}
      />
      <Dropdown label="Status" value={statusFilter} options={STATUS_OPTIONS} onChange={onStatusChange} />
      <Dropdown label="Sort" value={sort} options={SORT_OPTIONS} onChange={onSortChange} />
    </div>

    <div className="ma-toolbar__right">
      <button type="button" className="ma-btn ma-btn--ghost" onClick={onImportCsv}>
        <DownloadGlyph /> Import CSV
      </button>
      <button type="button" className="ma-btn ma-btn--ghost" onClick={onExportCsv}>
        <DownloadGlyph /> Export CSV
      </button>
      <button type="button" className="ma-btn ma-btn--primary" onClick={onInviteUsers}>
        Invite users
      </button>
    </div>
  </div>
);

export default Toolbar;
